// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from '@material-ui/core/Paper';
import type { Message as MessageType } from '../../types';

const NA = (
    <FormattedMessage
        id="general.na"
        defaultMessage="N/A"
    />
);

const getRecipient = (callsign?: string, user?: string) => {
    return (
        <React.Fragment>
            {callsign || NA} - {user || NA}
        </React.Fragment>
    );
};

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2)
    },
    date: {
        marginBottom: theme.spacing(0.5),
        paddingLeft: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium
    },
    message: {
        marginTop: theme.spacing(2)
    },
    allVehicles: {
        textTransform: 'uppercase'
    }
}));

export type Props = $ReadOnly<{
    message: MessageType,
    showRecipient?: boolean,
    callsign?: string,
    user?: string
}>;

function Message({ message, showRecipient, callsign, user }: Props) {
    const classes = useStyles();

    return (
        <div className={ classes.message }>
            <Typography classes={{ root: classes.date }} variant="caption" color="textSecondary" component="p">{message.date.toDate().toLocaleString()}</Typography>
            <Paper elevation={0} classes={{ root: classes.paper }}>
                {showRecipient &&
                    <Typography color="textSecondary" variant="subtitle2">
                        {message.icao ?
                            getRecipient(callsign, user)
                            :
                            <span className={classes.allVehicles}>
                                <FormattedMessage
                                    id="message.allVehicles"
                                    defaultMessage="All vehicles"
                                />
                            </span>
                        }
                    </Typography>
                }
                <Typography variant="body2" color="textSecondary" component="p">
                    {message.body}
                </Typography>
            </Paper>
        </div>
    );
}

export default Message;